import React from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import PageScrollTop from './components/pageToTop/PageScrollTop'

//Academy
import Academy from "./pages/Academy";

//Community
import Community from "./pages/Community";

// Main Pages 

import MainPage from "./pages/MainPage";
import EntrepriseMission from "./pages/EntrepriseMission";
import Benefits from "./pages/Benefits";
import HowitWorks from "./pages/HowitWorks";
import OneStopShop from "./pages/OneStopShop";
import ContactUs from "./pages/ContactUs";

//STOP SHOP PAGES
import Donations from "./pages/Donations";
import CompanyPrivate from "./pages/CompanyPrivate";
import EmployeeSavings from "./pages/EmployeeSavings";
import AccessCapital from "./pages/AccessCapital";
import BonusReward from "./pages/BonusReward";

//About
import AboutUs from "./pages/AboutUs";
import LegalNotice from "./pages/LegalNotice";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiesPolicy from "./pages/CookiesPolicy";

//About Bios
import CoreTeam from "./pages/CoreTeam";
import AdvisoryTeam from "./pages/AdvisoryTeam";
import ScientificTeam from "./pages/ScientificTeam";

//Login-Register
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import Register from "./pages/Register";

import Error from "./pages/Error";


// Import Css Here 
import './assets/scss/style.scss';


const App = () => {
    return (
        <Router>
            <PageScrollTop>
                <Switch>
                    {/* Academy */}
                    <Route path={`${process.env.PUBLIC_URL + "/academy"}`} exact component={Academy}/>

                    {/* Community */}
                    <Route path={`${process.env.PUBLIC_URL + "/community"}`} exact component={Community}/>

                    {/* Nav Pages  */}
                    <Route path={`${process.env.PUBLIC_URL + "/"}`} exact component={MainPage}/>
                    <Route path={`${process.env.PUBLIC_URL + "/entreprise-mission"}`} exact component={EntrepriseMission}/>
                    <Route path={`${process.env.PUBLIC_URL + "/benefits"}`} exact component={Benefits}/>
                    <Route path={`${process.env.PUBLIC_URL + "/functioning"}`} exact component={HowitWorks}/>
                    <Route path={`${process.env.PUBLIC_URL + "/offers"}`} exact component={OneStopShop}/>
                    <Route path={`${process.env.PUBLIC_URL + "/contact"}`} exact component={ContactUs}/>

                    {/* About  */}
                    <Route path={`${process.env.PUBLIC_URL + "/legal-notice"}`} exact component={LegalNotice}/>
                    <Route path={`${process.env.PUBLIC_URL + "/privacy-policy"}`} exact component={PrivacyPolicy}/>
                    <Route path={`${process.env.PUBLIC_URL + "/cookies-policy"}`} exact component={CookiesPolicy}/>
                    <Route path={`${process.env.PUBLIC_URL + "/about-us"}`} exact component={AboutUs}/>

                    {/* About Bios  */}
                    <Route path={`${process.env.PUBLIC_URL + "/about-us/core"}`} exact component={CoreTeam}/>
                    <Route path={`${process.env.PUBLIC_URL + "/about-us/advisory"}`} exact component={AdvisoryTeam}/>
                    <Route path={`${process.env.PUBLIC_URL + "/about-us/scientific"}`} exact component={ScientificTeam}/>

                    {/* Login-Register  */}
                    <Route path={`${process.env.PUBLIC_URL + "/login"}`} exact component={Login}/>
                    <Route path={`${process.env.PUBLIC_URL + "/forgot-password"}`} exact component={ForgotPassword}/>
                    <Route path={`${process.env.PUBLIC_URL + "/register"}`} exact component={Register}/>

                    {/* STOPSHOP  */}
                    <Route path={`${process.env.PUBLIC_URL + "/donations"}`} exact component={Donations}/>
                    <Route path={`${process.env.PUBLIC_URL + "/cse"}`} exact component={CompanyPrivate}/>
                    <Route path={`${process.env.PUBLIC_URL + "/employee-savings"}`} exact component={EmployeeSavings}/>
                    <Route path={`${process.env.PUBLIC_URL + "/access-capital"}`} exact component={AccessCapital}/>
                    <Route path={`${process.env.PUBLIC_URL + "/bonus-reward"}`} exact component={BonusReward}/>
                    <Route path={`${process.env.PUBLIC_URL + "/error"}`} exact component={Error}/>


                </Switch>
            </PageScrollTop>
        </Router>
    )
}


export default App
